/** Mirrors `CRM::GovernanceRolePolicy#manage?` for section governables. */
export function canManageSectionGovernance({
  isGlobalAdmin,
  assignedSectionLegacyIds,
  sectionLegacyId,
  hasManageCommitteesCapability
}: {
  isGlobalAdmin: boolean;
  assignedSectionLegacyIds: readonly string[];
  sectionLegacyId?: string | null;
  hasManageCommitteesCapability: boolean;
}): boolean {
  if (!sectionLegacyId) return false;
  if (isGlobalAdmin) return true;

  return hasManageCommitteesCapability || assignedSectionLegacyIds.includes(sectionLegacyId);
}
